
import React from 'react';

export default class ErrorBoundary extends React.Component {
   constructor(props) {
      super(props);
      this.state = { hasError: false };
   }

   static getDerivedStateFromError() {
      return { hasError: true };
   }

   componentDidCatch(error, info) {
      console.error('ErrorBoundary caught an error:', error, info);
   }

   handleReload = () => {
      this.setState({ hasError: false });
      window.location.reload();
   };

   render() {
      if (this.state.hasError) {
         if (this.props.fallback !== undefined) {
            return this.props.fallback;
         }
         return null;
      }

      return this.props.children;
   }
}
